import { render, staticRenderFns } from "./assigRules.vue?vue&type=template&id=6ff7b628&scoped=true&"
import script from "./assigRules.vue?vue&type=script&lang=js&"
export * from "./assigRules.vue?vue&type=script&lang=js&"
import style0 from "./assigRules.vue?vue&type=style&index=0&id=6ff7b628&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff7b628",
  null
  
)

export default component.exports